
class ArticleVideoContainer {
    constructor (theme, elem) {
        this._elem = elem
    }
    onInit () {
        let embeds = this._elem.querySelectorAll('iframe')
        // // console.log(embeds)
        if (embeds.length > 0) {
            for (let embed of embeds) {
                let container = document.createElement('div')
                container.classList.add('iframe-container')
                embed.parentNode.insertBefore(container, embed)
                container.appendChild(embed)
            }
        }
    }
}
export default ArticleVideoContainer



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ArticleVideoContainer.js